import { call, put, takeLatest } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

const endpoint = `${config.credentials.url}/stage-range`;

function* getStageRangeList(actions) {
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
    };

    const query = actions.query ? actions.query : "";
    const url = `${endpoint}/${query}`;

    const response = yield call(
      apiCall,
      "GET",
      url,
      { headers }
    );

    yield put({
      type: "STAGE_RANGE_LIST_RESPONSE",
      value: response,
    });

  } catch (error) {
    yield put({
      type: "STAGE_RANGE_ERROR",
      error,
    });
  }
}

function* getStageRangeDetail(actions) {
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
    };

    const url = `${endpoint}/${actions.id}/`;

    const response = yield call(
      apiCall,
      "GET",
      url,
      { headers }
    );

    yield put({
      type: "STAGE_RANGE_DETAIL_RESPONSE",
      value: response,
    });

  } catch (error) {
    yield put({
      type: "STAGE_RANGE_ERROR",
      error,
    });
  }
}

function* createStageRange(actions) {
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
    };

    const requestOptions = {
      headers,
      body: JSON.stringify(actions.payload),
    };

    const response = yield call(
      apiCall,
      "POST",
      `${endpoint}/`,
      requestOptions
    );

    console.log('API RAW STAGE_RANGE_CREATE_RESPONSE:', response);

    yield put({
      type: "STAGE_RANGE_CREATE_RESPONSE",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "STAGE_RANGE_CREATE_ERROR",
      error,
    });
  }
}

function* updateStageRange(actions) {
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
    };

    const requestOptions = {
      headers,
      body: JSON.stringify(actions.payload),
    };

    const response = yield call(
      apiCall,
      "PATCH",
      `${endpoint}/${actions.id}/`,
      requestOptions
    );

    console.log('API RAW STAGE_RANGE_UPDATE_RESPONSE:', response);


    yield put({
      type: "STAGE_RANGE_UPDATE_RESPONSE",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "STAGE_RANGE_UPDATE_ERROR",
      error,
    });
  }
}

export default function* sagaStageRangeAbm() {
  yield takeLatest("STAGE_RANGE_LIST_REQUEST", getStageRangeList);
  yield takeLatest("STAGE_RANGE_DETAIL_REQUEST", getStageRangeDetail);
  yield takeLatest("STAGE_RANGE_CREATE_REQUEST", createStageRange);
  yield takeLatest("STAGE_RANGE_UPDATE_REQUEST", updateStageRange);
}



